'use client'

import React, { ReactElement, useContext } from 'react'
import { OpenCloseContext } from '@/components/hotel/OpenCloseContext'
import classNames from 'classnames'

export function OpenCloseClickDetector(props: {
  children: ReactElement | ReactElement[],
  additionalClassName?: string
}): ReactElement {
  const { open, setOpen } = useContext(OpenCloseContext)!

  return <div
    className={classNames('cursor-pointer', props.additionalClassName)}
    onClick={() => setOpen(!open)}>{props.children}</div>
}